import React, { useContext, useMemo } from 'react';

import CheckboxInput from '../../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import ArrayInputConfig from '../../../../../Components/ArrayInputConfig';
import PageHeading from '../../../../../Components/PageHeading';
import InputConfig from '../../../../../Components/InputConfig';
//mui imports====
import { Grid } from '@mui/material';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import { Paper } from '@mui/material';
import commonStyles from '../../../../../commonStyles';
import GeneralTab from '../../../../../Components/GeneralTabAndTabContent';

const CustomVastTagTabConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = commonStyles();

	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	const tabListAndPanels = useMemo(() => {
		return [
			{
				tab: <Tab label="Single Vast Tag" value="SingleCustomVastTag" key="SingleCustomVastTag" />,
				tabPanel: (
					<TabPanel
						value="SingleCustomVastTag"
						key="SingleCustomVastTag"
						sx={{ padding: 0, marginTop: '1.5rem' }}
					>
						<InputConfig
							label="Custom Vast Tag Url"
							keyData={keyData + '.url'}
							inputType="text"
							object={rawConfig}
							updateObject={updateRawConfig}
							editable={!!rawConfig[keyData + '.enabled']}
							containerStyles={{
								width: '60%',
								marginLeft: '5rem',
								paddingBottom: '4rem'
							}}
							inputStyles={{ width: '100%', marginTop: '1rem' }}
							labelStyles={{ width: '100%', marginBottom: '3rem' }}
						/>
					</TabPanel>
				)
			},
			{
				tab: (
					<Tab
						label="Multiple Vast Tag"
						value="MultipleCustomVastTag"
						key="MultipleCustomVastTag"
					/>
				),
				tabPanel: (
					<TabPanel
						value="MultipleCustomVastTag"
						key="MultipleCustomVastTag"
						sx={{ padding: '0 0 3rem 5rem', marginTop: '1.5rem' }}
					>
						<ArrayInputConfig
							label="Multiple Custom VastTag"
							keyData={keyData + '.urlsArray'}
							object={rawConfig}
							entireArrayEditable={!!rawConfig[keyData + '.enabled']}
							updateObject={updateRawConfig}
							inputGridStyle={{ display: 'flex' }}
						/>
					</TabPanel>
				)
			}
		];
	}, [keyData, rawConfig, updateRawConfig]);

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Custom Vast Tag"
				headingPath={['Dashboard', 'Framerate', 'Network Data', 'Custom Vast Tag']}
				description="Manage Custom Vast Tag Inventory here."
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid item xs={6} style={{ marginTop: '6rem', marginLeft: '5rem' }}>
				<CheckboxInput
					keyData={keyData + '.enabled'}
					label="Enabled"
					disabled={false}
					defaultChecked={false}
					containerStyles={{ width: 'fit-content' }}
					object={rawConfig}
					updateObject={updateRawConfig}
				/>
			</Grid>

			<GeneralTab
				tabListAndPanels={tabListAndPanels}
				tabListStyles={{ width: 'fit-content', margin: '4rem 0 6rem 5rem' }}
			/>
		</Paper>
	);
};

export default CustomVastTagTabConfig;
